<template>
    <div class="voucher">
        <div class="container">
            <ul class="breadcrumb d-print-none">
                <li class="breadcrumb-item">
                    <router-link :to="{name: 'Home'}">Página Principal</router-link>
                </li>
                <li class="breadcrumb-item">
                    <span>Pagamento Compra de Cartão GrupoSin</span>
                </li>
            </ul>
            <div class="d-none d-print-block">
                <div class="row mt-4">
                    <div class="col-md-3">
                        <img src="@/img/brand-drachei-big.svg" alt="" class="img-fluid">
                    </div>
                    <div class="col-md-1 offset-7">
                        <img src="@/img/drachei-card.png" alt="" class="img-fluid pt-3">
                        
                    </div>
                    <div class="col-md-1">
                        <img src="@/img/grupo-sin.png" alt="" class="img-fluid">
                    </div>
                </div>
                <hr>
            </div>
            <div class="" v-if="cartao"> 
                <div class="row">
                    <div class="col-md-12 col-sm-12 element-box">
                      <div class="row" v-if="cartao.numeroCartao">
                        <div class="col">
                          <div class="alert alert-success" role="alert">
                            <strong class="fas fa-check-circle text-success"></strong>
                              <b>FAÇA SEU LOGIN E SENHA NA AREA DO CLIENTE PARA COMPRAR SEU
                              SERVIÇO NA PLATAFORMA DR. ACHEI PELO MENOR PREÇO. SEU CARTÃO SERÁ ENVIADO E CHEGA EM SUA
                              RESIDÊNCIA EM 10 DIAS ÚTEIS.</b>
                              <p class="text-danger" v-if="isSeguroInternacao">
                                  A EMISSÃO DE SUA APÓLICE SERÁ REALIZADA E ENVIADA PARA SEU EMAIL EM ATÉ 36 HORAS ÚTEIS.
                              </p>
                          </div>
                        </div>
                      </div>

                        <div class="row">
                            <div class="col-md-9 col-sm-8">
                                <div class="element-wrapper pb-2 ">
                                    <h3 v-if="cartao.numeroCartao" class="text-success"><i class="fas fa-check-circle"></i> Compra Confirmada</h3>
                                    <h3 v-else class="text-warning"><i class="fas fa-check-circle"></i> Aguardando Pagamento</h3>
                                </div>  
                            </div>
                            <div class="col-md-3 col-sm-4">
                                <div class="element-wrapper pb-2 text-right">
                                    <label>Número Pedido</label>
                                    <h4 class="text-info">{{cartao.vads_trans_id}}</h4>
                                </div>  
                            </div>
                        </div>
                        <div class="row" v-if="cartao.status && cartao.status.toLocaleUpperCase() === 'AGUARDANDO_PAGAMENTO'">
                            <div class="col">
                                <div class="element-wrapper pb-2 text-right">
                                    <a target="_blank" :href="cartao.linkBoleto" class="btn btn-warning">
                                        <i class="fa fa-file-pdf"></i>
                                        Imprimir Boleto
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="element-wrapper">
                                    <h5 class="element-header">
                                        Cliente
                                    </h5>
                                    <div class="row">
                                        <div class="col">
                                            <div class="label">Nome</div>
                                            <h6>{{cartao.client.name}}</h6>
                                        </div>
                                        <div class="col">
                                            <div class="label">CPF</div>
                                            <h6>{{cartao.client.cpf}}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="element-wrapper">
                                <h5 class="element-header">
                                    Cartão
                                </h5>
                                <div class="row">
                                  <div class="col">
                                    <div class="label">Número</div>
                                    <h6>{{cartao.numeroCartao.replace(/(\d\d\d\d)(\d\d\d\d)(\d\d\d\d)(\d\d\d\d)/g, '$1 $2 $3 $4')}}</h6>
                                  </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="label">Plano</div>
                                        <h6>{{cartao.plano.name}}</h6>
                                    </div>
                                    <div class="col">
                                        <div class="label">Valor</div>
                                        <h6>{{cartao.plano.price | money}}/mês</h6>
                                    </div>
                                    <div class="col">
                                        <div class="label">Forma de Pagamento</div>
                                        <h6>{{cartao.vads_payment_cards.descricao}}</h6>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                        <div class="invoice-footer">
                            <div class="invoice-logo">
                               <span>Dr.Achei</span>
                            </div>
                            <div class="invoice-info">
                                <span>contato@drachei.com.br</span><span>21 2263-9325</span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col offset-1 text-right d-print-none">
                        <div><a class="btn btn-primary mb-3" href="javascript:window.print()"><i class="os-icon os-icon-newspaper"></i><span>Imprimir</span></a></div>
                        <a class="btn btn-primary" href="#"><i class="os-icon os-icon-email-forward"></i><span>Reenviar por e-mail</span></a>
                        <hr>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as http from 'axios'
import moment from 'moment'
export default {
  async created () {
    moment.locale('pt-br')
    let id = this.$route.query.id
    const response = await http.get(`/saudes/${id}`)
    this.cartao = response.data
  },
  computed: {
    isSeguroInternacao () {
      return this.cartao.plano && this.cartao.plano.name === 'SEGURO INTERNAÇÃO DR ACHEI'
    }
  },
  data () {
    return {
      pedido: {
        cliente: {}
      },
      cartao: null
    }
  },
  methods: {
    getDataFormatada (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/pagamentos/VoucherCartao.vue